import React from 'react'
import Layout from '../layout/Layout'
import Slider from '../components/Slider'
import Feature from '../components/Feature'
import Services from '../components/Services'
import Testimonials from '../components/Testimonials'
import SEO from '../components/SEO'

function Home() {
  return (
    <Layout>
        <SEO
          title="Papreja Tech Solutions | Practical Technology for Growing Businesses"
          description="Papreja Tech Solutions helps businesses move forward with practical technology, thoughtful design, and dependable engineering."
          path="/"
        />
        <Slider />
        <Services />
        <Feature />
        <Testimonials />
    </Layout>
  )
}

export default Home
